import PropTypes from 'prop-types'
import React from 'react'
import styles from './nav.module.scss'
import SubLevel from 'components/Nav/subcomponents/SubLevel'
import { NavKeyboardProvider } from 'components/Nav/NavKeyboardContext'
import clsx from 'clsx'

const Nav = ({ items = [], level = 1, collapse = false, className, parentKey = null }) => {
  const list = (
    <div
      className={clsx(
        styles['nav'],
        collapse ? styles['nav_collapsed'] : styles['nav_expanded'],
        className,
      )}
    >
      <nav className={styles['nav__list']}>
        {items.map((props, index) => {
          //eslint-disable-next-line
          const { label_key, label, key } = props
          if (!label_key && !label) return null

          const itemKey = key != null ? String(key) : `${parentKey ?? 'root'}-${index}`

          return (
            <SubLevel
              {...props}
              key={itemKey}
              collapse={collapse}
              itemIndex={index}
              itemKey={itemKey}
              level={level}
              parentKey={parentKey}
              routeKey={key}
            />
          )
        })}
      </nav>
    </div>
  )

  if (level === 1) {
    return <NavKeyboardProvider>{list}</NavKeyboardProvider>
  }

  return list
}

Nav.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
  items: PropTypes.array,
  simple: PropTypes.bool,
  open: PropTypes.bool,
  level: PropTypes.number,
  parentKey: PropTypes.string,
}

export default Nav
